import { Component } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject, takeUntil } from "rxjs";
import {
  ActivityNote,
  AddActivityNotePayload,
} from "src/app/core/models/activity-notes.model";
import { BroadcastEventTypes } from "src/app/core/models/lookup.model";
import { chartEncounterActivityPayload } from "src/app/core/helpers/activity-encounter-context.util";
import { ActivityNotesService } from "src/app/core/services/activity-notes.service";
import { ApplicationCacheService } from "src/app/core/services/application-cache.service";
import { ApplicationContextService } from "src/app/core/services/application-context.service";
import { EventService } from "src/app/core/services/event.service";

@Component({
  selector: "app-add-activity-modal",
  templateUrl: "./add-activity-modal.component.html",
  styleUrls: ["./add-activity-modal.component.scss"],
})
export class AddActivityModalComponent {
  /** Procedure room Add Action modal — stored as a nurse note. */
  isNurseNote = true;
  isSaving: boolean;
  note: string;
  loggedInUserName: string;
  private readonly destroy$ = new Subject<void>();
  constructor(
    public bsModalRef: BsModalRef,
    private readonly _appContextService: ApplicationContextService,
    private readonly _applicationCacheService: ApplicationCacheService,
    private readonly _activityNoteService: ActivityNotesService,
    private readonly _eventService: EventService
  ) {
    this._appContextService.context
      .pipe(takeUntil(this.destroy$))
      .subscribe((context) => {
        this.loggedInUserName =
          context.currentlyLoggedInUser.firstName +
          " " +
          context.currentlyLoggedInUser.lastName;
      });
  }

  saveActivityNote() {
    this.isSaving = true;
    this._activityNoteService
      .addNewActivityNote(this.buildActivityNotePayload())
      .subscribe({
        next: (activityNote: ActivityNote) => {
          this._eventService.broadcast(
            BroadcastEventTypes.ActivityNoteAdded,
            activityNote
          );
          this.bsModalRef.hide();
        },
        error: (err) => {
},
      })
      .add(() => (this.isSaving = false));
  }

  get patientId() {
    return this._applicationCacheService.applicationCache.patient.id;
  }

  get procedureId() {
    return this._applicationCacheService.applicationCache.procedureListing.id;
  }

  private buildActivityNotePayload(): AddActivityNotePayload {
    const cache = this._applicationCacheService.applicationCache;
    const encounterId = String(
      cache?.procedureListing?.encounterId ||
        cache?.appointment?.id ||
        cache?.procedure?.encounterId ||
        ""
    ).trim();
    return chartEncounterActivityPayload({
      patientId: this.patientId,
      procedureId: this.procedureId,
      notes: this.note,
      activityBy: this.loggedInUserName,
      activityType: "Action",
      isNurseNote: true,
      ...(encounterId ? { encounterId } : {}),
    });
  }
}
